import { ScrollLock } from '../../../js/utils/scroll-lock.js'
import { FocusLock } from '../../../js/utils/focus-lock.js'

const OVERLAY_SELECTOR = '[data-menu-overlay]'
const TRIGGER_SELECTOR = '[data-menu-overlay-trigger]'
const CLOSE_SELECTOR = '[data-menu-overlay-close]'

export function initMenuOverlay() {
  const overlay = document.querySelector(OVERLAY_SELECTOR)
  const triggers = document.querySelectorAll(TRIGGER_SELECTOR)

  if (!overlay || !triggers.length) {
    return
  }

  const scrollLock = new ScrollLock()
  const focusLock = new FocusLock()

  const onDocumentKeydown = (evt) => {
    if (evt.key === 'Escape' || evt.key === 'Esc') {
      close()
    }
  }

  const isOpen = () => overlay.classList.contains('is-open')

  const open = () => {
    if (isOpen()) {
      return
    }
    overlay.classList.add('is-open')
    overlay.setAttribute('aria-hidden', 'false')
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'))
    document.documentElement.classList.add('menu-overlay-is-open')
    scrollLock.disableScrolling()
    focusLock.lock(`${OVERLAY_SELECTOR}.is-open`, true)
    document.addEventListener('keydown', onDocumentKeydown)
  }

  const close = () => {
    if (!isOpen()) {
      return
    }
    focusLock.unlock(true)
    overlay.classList.remove('is-open')
    overlay.setAttribute('aria-hidden', 'true')
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'))
    document.documentElement.classList.remove('menu-overlay-is-open')
    scrollLock.enableScrolling()
    document.removeEventListener('keydown', onDocumentKeydown)
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (isOpen()) {
        close()
      } else {
        open()
      }
    })
  })

  overlay.addEventListener('click', (evt) => {
    if (evt.target.closest(CLOSE_SELECTOR)) {
      close()
    }
  })
}
